import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
// import { dimensions } from 'modules/common/styles';
import { BreadCrumb, Filter } from 'modules/theme';
import { dimensions } from '../../common/styles';
import MainBar from './MainBar';

const propTypes = {
  breadcrumb: PropTypes.array.isRequired,
  queryParams: PropTypes.object
};

const PageHeader = styled.div`
  height:56px;
  border-bottom:1px solid #D9D9D9;
  width:100%;
  padding:0px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 768px) {
    display: none;
  }
`;

function Header({ breadcrumb = [], queryParams }) {
  return (
    <PageHeader className='pageHeader'>
      {window.location.pathname === "/chat-screen" &&
        <span
          className='beta-wrapper d-inline m-0'
          style={{
            // padding: "0.25rem 0.5rem",
            borderRadius: "2rem",
            fontSize: 12,
            fontWeight: 700,
            letterSpacing: "0.2rem"
          }}
        >
          
        </span>
      }
      <BreadCrumb breadcrumbs={breadcrumb} />
      {queryParams && <Filter queryParams={queryParams} />}
      <MainBar />
    </PageHeader>
  );
}

Header.propTypes = propTypes;

export default Header;



// WEBPACK FOOTER //
// src/modules/theme/theme1/layout/components/Header.js